import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NavigationGuard } from '@app/guards';
import { PermissionGuard } from '@app/guards/permission.guard';
import { RoutesWithOptions } from '@app/interfaces';
import { CompanyDocument } from '@app/models/documents/company-document.model';
import {
    CompanyDocumentAssignmentsView,
    CompanyDocumentsBulkUploadView,
    CompanyDocumentShowView,
    DocumentFoldersIndexView,
    EmployeeDocumentShowView,
    EmployeeDocumentSignView,
    SigningTemplateEditorView,
} from '@documents-v2/views';
import { DocumentsV2Resolver } from '../documents-v2/documents-v2.resolver';

const routes: RoutesWithOptions = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: '/documents/center',
    },
    {
        path: 'center',
        canActivate: [PermissionGuard],
        data: { permission: CompanyDocument.permission.view },
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'folders',
            },
            {
                path: 'bulk-upload',
                component: CompanyDocumentsBulkUploadView,
                canDeactivate: [NavigationGuard],
            },
            {
                path: 'folders',
                children: [
                    {
                        path: '',
                        component: DocumentFoldersIndexView,
                    },
                    {
                        path: ':node',
                        component: DocumentFoldersIndexView,
                    },
                ],
            },
        ],
    },
    {
        path: 'center/:companyDocument',
        resolve: {
            models: DocumentsV2Resolver,
        },
        children: [
            {
                path: '',
                component: CompanyDocumentShowView,
            },
            {
                path: 'assigned',
                component: CompanyDocumentAssignmentsView,
                canActivate: [PermissionGuard],
                data: { permission: CompanyDocument.permission.view },
            },
            {
                path: 'signingTemplate/:signingTemplate',
                component: SigningTemplateEditorView,
                canActivate: [PermissionGuard],
                data: { permission: CompanyDocument.permission.view },
            },
        ],
    },

    {
        path: 'employees/:employee/employee-documents/:employeeDocument',
        resolve: { models: DocumentsV2Resolver },
        children: [
            {
                path: '',
                component: EmployeeDocumentShowView,
            },
            {
                path: 'sign',
                component: EmployeeDocumentSignView,
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class DocumentRouterModule {}
